import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspace: {
        route: "/workspaces/:workspaceId",
        method: "GET"
    },
    updateWorkspace: {
        route: "/workspaces/:workspaceId",
        method: "PUT"
    },
    createWorkspace: {
        route: "/workspaces",
        method: "POST"
    },
    deleteWorkspace: {
        route: "/workspaces/:workspaceId",
        method: "DELETE"
    }
};
